// extracted by mini-css-extract-plugin
export default {"container":"LectureContentInput_container__XaVfV","editorContainer":"LectureContentInput_editorContainer__TQsyC"};